import React from 'react';
// Modified the Dropbox link with raw=1 so it streams the video directly instead of opening the Dropbox webpage
const VIDEO_URL = 'https://www.dropbox.com/scl/fi/25r2b6nqgprwhskwu20kh/yessss-2.mp4?rlkey=z323fhpqhn1g0w0rcfh0pqg7n&st=waz9d1ii&raw=1';
export function Home() {
  return <main className="bg-black" data-id="element-213">
      {/* Hero Section - Fullscreen Looping Video */}
      <section className="relative h-screen w-full overflow-hidden bg-darkroom-900" data-id="element-214">
        <video src={VIDEO_URL} autoPlay muted loop playsInline className="absolute inset-0 z-0 h-full w-full object-cover" data-id="element-215" />

        {/* Subtle vignette so corners + edges (nav area) stay legible */}
        <div className="pointer-events-none absolute inset-0 z-20" style={{
        background: 'radial-gradient(ellipse at center, transparent 40%, rgba(0,0,0,0.55) 100%)'
      }} data-id="element-216" />
      </section>

      {/* YouTube Video Section */}
      <section className="relative flex min-h-screen w-full items-center justify-center bg-black px-4 py-24 md:px-12" data-id="element-217">
        <div className="w-full max-w-6xl aspect-video overflow-hidden rounded-xl border border-zinc-900 bg-zinc-950 shadow-[0_0_50px_rgba(0,0,0,0.8)]" data-id="element-218">
          <iframe width="100%" height="100%" src="https://www.youtube.com/embed/mmkvabvHiDY?autoplay=0&rel=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen className="h-full w-full" data-id="element-219"></iframe>
        </div>
      </section>
    </main>;
}